import { MEDIA_TYPE } from '../types';
import getUserAgent from './getUserAgent';

/**
 * Check if the canPlay event bug is present in the current browser version
 * which should just be safari.
 *
 * Note:
 * `canplay` event will fail to emit when initializing media using ios native
 * hls.
 *
 * reference: https://webkit.org/blog/15383/webkit-features-in-safari-17-5/
 * and https://developer.apple.com/forums/thread/748001.
 */
export const checkForCanPlayEventBug = (
  mediaType: MEDIA_TYPE = 'video'
): boolean => {
  const { name, major, minor } = getUserAgent() || {};

  if (!name || !major || !minor) {
    return false;
  }

  const isSafari = name === 'Safari' || name === 'Mobile Safari';

  if (isSafari) {
    if (mediaType === 'audio') {
      return true;
    }

    return parseInt(major, 10) <= 17 && parseInt(minor, 10) <= 5;
  }

  return false;
};

export default checkForCanPlayEventBug;
